import { render } from "./CancellatioinPolicySchemajson.vue?vue&type=template&id=2f788a64"
import script from "./CancellatioinPolicySchemajson.vue?vue&type=script&lang=js"
export * from "./CancellatioinPolicySchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__